import { render } from "./LajnaPage.vue?vue&type=template&id=677c256f"
import script from "./LajnaPage.vue?vue&type=script&lang=js"
export * from "./LajnaPage.vue?vue&type=script&lang=js"

import "./LajnaPage.vue?vue&type=style&index=0&id=677c256f&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__